<template>
  <div class="interfacemanage">
    <div class="content_wrapper">
      <div class="box-card">
        <div class="info-header">
          <div class="title">{{companyInfo.companyName}}</div>
          <div class="add">详细地址：{{companyInfo.companyAddress}}</div>
          <div class="time">注册时间：{{companyInfo.registerTime}}</div>
          <div>
            <el-button plain @click="goto('devinfo')">开发者信息</el-button>
            <el-button type="primary" v-if="![6, 7].includes(devStatus)">接口管理</el-button>
            <el-button plain @click="goto('istatisticsCustomer')"> 调用统计</el-button>
            <template v-if="valid('API_MANAGE_USER')">
              <span v-if="devStatus == '1' || devStatus == '3'">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
              <el-button plain @click="gotoOpenRenew" v-if="devStatus == '1' || devStatus == '3'">批量开通</el-button>
              <el-button plain @click="useDelay" v-if="devStatus == '1'">试用延期</el-button>
              <el-button plain @click="openTrial" v-if="devStatus == '3'">开通试用</el-button>
              <el-button plain @click="openZuhe('open')">组合开通</el-button>
            </template>
          </div>
          <div class="user">
            <img v-if="devStatus == '2'" src="../../../assets/images/icon/on-use.png"/><span v-if="devStatus == '2'" style="color:#996e52;">正式用户</span>
            <img v-if="devStatus == '1'" src="../../../assets/images/icon/try.png"/><span v-if="devStatus == '1'" style="color:#479efe;">试用用户</span>
            <img v-if="devStatus == '3'" src="../../../assets/images/icon/outDate.png"/><span v-if="devStatus == '3'" style="color:#666;">过期用户</span>
            <img v-if="devStatus == '0'" src="../../../assets/images/icon/invalid.png"/><span v-if="devStatus == '0'" style="color:#878787;">未生效用户</span>
            <img v-if="devStatus == '4'" src="../../../assets/images/icon/forbiden.png"/><span v-if="devStatus == '4'" style="color:#ed4a3a;">禁用用户</span>
            <img v-if="devStatus == '5'" src="../../../assets/images/icon/other.png"/><span v-if="devStatus == '5'" style="color:#4a6589;">其他用户</span>
            <img v-if="devStatus == '6'" src="../../../assets/images/icon/other.png"/><span v-if="devStatus == '6'" style="color:#878787;">待审核</span>
            <img v-if="devStatus == '7'" src="../../../assets/images/icon/other.png"/><span v-if="devStatus == '7'" style="color:#ed4a3a;">审核拒绝</span>
          </div>
        </div>
      </div>

      <div class="box-card">
        <div>
          <div class="tlc" style="margin-bottom:16px;">
            <el-radio-group v-model="type" size="small">
              <el-radio-button label="1">按时间</el-radio-button>
              <el-radio-button label="2">按数量</el-radio-button>
            </el-radio-group>
          </div>
          <!-- 按时段开通  显示资源 -->
          <el-table
          v-show="type == 1"
          :data="timeTable"
          border
          header-row-class-name="header-row-class-name"
          style="width: 100%">

            <el-table-column
            label="接口名称"
            align="center">
              <template slot-scope="scope">
                {{scope.row.apiResourceDto.name}}
              </template>
            </el-table-column>

            <!-- <el-table-column
              label="接口开通类型"
              width="120"
              align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.type === 1">按时段</div>
                <div v-if="scope.row.type === 2">按数量</div>
              </template>
            </el-table-column> -->

            <el-table-column
              label="开通时段"
              prop="startTime"
              align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.type === 1">{{scope.row.startTime}} 至 {{scope.row.endTime}}</div>
                <div v-else>/</div>
              </template>
            </el-table-column>

            <el-table-column
            label="剩余天数"
            prop="surplusDays"
            width="120"
            align="center">
            </el-table-column>

            <el-table-column
              label="每日接口调用上限"
              align="center"
              width="150"
              prop="maxInvokePerDay">
            </el-table-column>

            <el-table-column
              label="每日去重下载上限"
              align="center"
              width="150"
              prop="maxDownloadPerDay">
            </el-table-column>

            <el-table-column
            label="状态"
            width="120"
            align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.status === 2" style="color:#36B935;">服务中</span>
                <span v-if="scope.row.status === 1" style="color:#479efe;">试用</span>
                <span v-if="scope.row.status === 3" style="color:#666;">过期</span>
                <span v-if="scope.row.status === 0" style="color:#878787;">未生效</span>
                <span v-if="scope.row.status === 4" style="color:#ed4a3a;">禁用</span>
                <span v-if="scope.row.status === 9" style="color:#666;">/</span>
              </template>
            </el-table-column>

            <el-table-column label="操作" v-if="valid('API_MANAGE_USER')">
              <template slot-scope="scope">
                <el-button type="text" size="small" v-if="scope.row.status == 1 || scope.row.status == 3" @click="openService(scope.row)">开通</el-button>
                <el-button type="text" size="small" v-if="scope.row.status == 2" @click="renewal(scope.row)">续费</el-button>
                <el-button type="text" v-if="scope.row.status == 2 || scope.row.status == 1" size="small" @click="disableDev(scope.row.id)">禁用</el-button>
                <el-button type="text" v-if="scope.row.status == 4" size="small" @click="enableDev(scope.row.id)">启用</el-button>
                <el-button type="text" v-if="scope.row.status == 2 || scope.row.status == 1" size="small" @click="modifyService(scope.row.permissionId)">修改调用限制</el-button>
                <el-button type="text" v-if="scope.row.status == 9" size="small" @click="openZuhe('edit')">修改组合限制</el-button>
                <el-button type="text" v-if="scope.row.status == 9" size="small" @click="delZuhe()">删除</el-button>
              </template>
            </el-table-column>
          </el-table>

          <!-- 按调用量开通 显示资源 -->
          <el-table
            v-show="type == 2"
            :data="numberTable"
            header-row-class-name="header-row-class-name"
            border
            style="width: 100%">

            <el-table-column
            label="接口名称"
            align="center">
              <template slot-scope="scope">
                {{scope.row.apiResourceDto.name}}
              </template>
            </el-table-column>

            <!-- <el-table-column
              label="接口开通类型"
              width="120"
              align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.type === 1">按时段</div>
                <div v-if="scope.row.type === 2">按数量</div>
              </template>
            </el-table-column> -->

            <el-table-column
            label="接口调用上限"
            prop="invokeLimit"
            align="center">
            </el-table-column>

            <el-table-column
            label="去重下载上限"
            prop="downloadLimit"
            align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.apiResourceDto.id == 1">/</div>
                <div v-else>{{scope.row.downloadLimit}}</div>
              </template>
            </el-table-column>

            <!-- <el-table-column
            label="调用总量"
            prop="invokeCount"
            align="center">
            </el-table-column> -->

            <el-table-column
            label="去重下载"
            prop="downloadCount"
            align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.apiResourceDto.id == 1">/</div>
                <div v-else>{{scope.row.downloadCount}}</div>
              </template>
            </el-table-column>

            <el-table-column
            label="累计下载"
            prop="totalDownloadCount"
            align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.apiResourceDto.id == 1">/</div>
                <div v-else>{{scope.row.totalDownloadCount}}</div>
              </template>
            </el-table-column>

            <el-table-column
            label="状态"
            width="120"
            align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.status === 2" style="color:#36B935;">服务中</span>
                <span v-if="scope.row.status === 1" style="color:#479efe;">试用</span>
                <span v-if="scope.row.status === 3" style="color:#666;">过期</span>
                <span v-if="scope.row.status === 0" style="color:#878787;">未生效</span>
                <span v-if="scope.row.status === 4" style="color:#ed4a3a;">禁用</span>
              </template>
            </el-table-column>

            <el-table-column label="操作" align="center" v-if="valid('API_MANAGE_USER')">
              <template slot-scope="scope">
                <el-button type="text" v-if="scope.row.status == 1 || scope.row.status == 3" @click="openService(scope.row)">开通</el-button>
                <el-button type="text" v-if="scope.row.status == 2" @click="renewal(scope.row)">续费</el-button>
                <el-button type="text" v-if="scope.row.status == 2 || scope.row.status == 1" @click="disableDev(scope.row.id)">禁用</el-button>
                <el-button type="text" v-if="scope.row.status == 4" @click="enableDev(scope.row.id)">启用</el-button>
              </template>
            </el-table-column>

          </el-table>

        </div>
      </div>
    </div>
    <!--开通弹框-->
    <open-dialog v-model="openDialogVisible" :renewalData="renewalData" @success="refresh"></open-dialog>
    <!--续费弹框-->
    <renew-dialog v-model="renewDialogVisible" :renewData="renewData" @success="refresh"></renew-dialog>
    <!--修改调用限制弹框-->
    <modify-dialog v-model="modifyDialogVisible" :rowData="rowData" @success="refresh"></modify-dialog>
    <!-- 组合开通弹窗 -->
    <zuhe-dialog v-model="zuheDialogVisible" :rowData="zuheData" @success="refresh"></zuhe-dialog>
  </div>
</template>
<script type="text/babel">
import openDialog from './open-dialog/index.vue'
import modifyDialog from './modify-dialog/index.vue'
import renewDialog from './renew-dialog/index.vue'
import zuheDialog from './zuhe-dialog/index.vue'
import devService from '@/service/devService'
import adminMixin from '@/mixins/adminMixin'
import { mapGetters } from 'vuex'

export default {
  mixins: [adminMixin],
  components: {
    openDialog: openDialog,
    modifyDialog: modifyDialog,
    renewDialog: renewDialog,
    zuheDialog: zuheDialog
  },
  name: 'interfaceManage',
  data () {
    return {
      // companyInfo: {},
      developSecource: [],
      timeTable: [],
      numberTable: [],
      emptyData: [{}],
      history: {},
      pageNumber: 0,
      pageSize: 10,
      total: 0,
      openDialogVisible: false,
      modifyDialogVisible: false,
      renewDialogVisible: false,
      zuheDialogVisible: false,
      rowData: {
        apiResourceDto: {}
      },
      renewData: {
        apiResourceDto: {}
      },
      zuheData: {

      },
      id: 0,
      renewalData: {
        apiResourceDto: {}
      },
      devStatus: '',
      today: '',
      endDay: '',
      type: '1'
    }
  },
  mounted () {
    // 加载用户开通信息
    this.id = this.companyInfo.id
    this.today = new Date().Format(this.SysConstant.DATE_FORMATE)
    this.fetchDevResource()
    this.getDeveloperStatus()
  },
  computed: {
    ...mapGetters(['companyInfo'])
  },
  methods: {
    // 获取开发者状态
    async getDeveloperStatus () {
      try {
        this.devStatus = await devService.getDeveloperStatus({developerId: this.companyInfo.id})
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    // 获取组合开通信息
    async getDeveloperZuhe () {
      try {
        let res = await devService.getZuheOpen({userId: this.id})
        if (!res) {
          return;
        }
        res = {
          ...res,
          maxInvokeName: res.name,
          surplusDays: '/',
          type: 9,
          status: 9
        }
        this.zuheData = res
        this.timeTable.push({
          ...res,
          apiResourceDto: {
            name: res.maxInvokeName
          },
          order: 999
        })
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    // 续费开通
    gotoOpenRenew () {
      this.$router.push({name: 'openAndRenew', query: {id: this.id}})
    },
    // 续费
    renewal (data) {
      this.renewData = data
      // alert(111)
      this.renewDialogVisible = true
    },
    // 开通
    openService (data) {
      this.renewalData = data
      this.openDialogVisible = true
    },
    // 查询用户开通详情
    async fetchDevResource () {
      try {
        this.developSecource = await devService.getDevelopStatistics({developerId: this.id})
        if (this.developSecource) {
          this.endDay = this.developSecource[0].endTime
        }
        this.numberTable = []
        this.timeTable = []
        let sortArr = ['通用', '文档', '试卷', '试题', '微课'];
        this.developSecource.forEach((item) => {
          if (item.type == 2) {
            this.numberTable.push({
              ...item,
              order: sortArr.indexOf(item.apiResourceDto.name) > -1 ? sortArr.indexOf(item.apiResourceDto.name) : 999
            })
          } else {
            this.timeTable.push({
              ...item,
              order: sortArr.indexOf(item.apiResourceDto.name) > -1 ? sortArr.indexOf(item.apiResourceDto.name) : 999
            })
          }
          this.numberTable = this.numberTable.sort((a, b) => {
            return a.order - b.order
          })
          this.timeTable = this.timeTable.sort((a, b) => {
            return a.order - b.order
          })
          this.type = this.timeTable.length > 0 ? 1 : 2;
        })
        this.getDeveloperZuhe()
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    // 刷新列表及刷新用户状态
    refresh () {
      this.fetchDevResource()
      this.getDeveloperStatus()
    },
    // 试用延期
    async useDelay () {
      this.$confirm('是否确定试用延期, 会自动为客户延期7天试用期限?', '试用延期', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await devService.getDelay({developerId: this.id})
        this.$message.success('已延期')
        this.fetchDevResource()
        this.getDeveloperStatus()
      }).catch((e) => {
      //  this.$message.error(e && e.msg)
      })
    },
    // 开通试用
    async openTrial () {
      let list = this.developSecource
      let flag = 0
      list.forEach((item) => {
        if (item && item.status == 4) {
          this.$message.error('有资源处于禁用状态，请先解除其禁用状态！')
          flag = 1
        }
      })

      if (flag === 1) {
        return
      }
      this.$confirm('是否确定开通试用, 会自动为客户开通7天试用?', '开通试用', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await devService.getDelay({developerId: this.id})
        this.$message.success('已开通试用')
        this.fetchDevResource()
        this.getDeveloperStatus()
      }).catch((e) => {
     //   this.$message.error(e && e.msg)
      })
    },
    // 组合开通
    openZuhe(type) {
      this.zuheDialogVisible = true;
    },
    delZuhe() {
      this.$confirm('是否确定删除组合限制?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await devService.delZuheOpen({userId: this.id})
        this.$message.success('已删除组合限制')
        this.zuheData = {};
        this.fetchDevResource()
      }).catch((e) => {
     //   this.$message.error(e && e.msg)
      })
    },
    // 跳转页面
    goto (name) {
      this.$router.push({name: name})
    },
    // 禁用
    async disableDev (id) {
      this.$confirm('此操作将禁用该资源, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await devService.disableDev(id)
        this.$message.success(this.SysConstant.success)
        this.fetchDevResource()
        this.getDeveloperStatus()
      }).catch((e) => {
     //   this.$message.error(e && e.msg)
      })
    },
    // 启用
    async enableDev (id) {
      try {
        await devService.enableDev(id)
        this.$message.success(this.SysConstant.success)
        this.fetchDevResource()
        this.getDeveloperStatus()
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },

    // 修改调用限制
    async modifyService (id) {
      try {
        this.rowData = await devService.getResourcePermiss({permissionId: id})
        // this.rowData.name = rowData.apiResourceDto.name
        // console.log(this.rowData)
        this.modifyDialogVisible = true
        // this.$message.success(this.SysConstant.success)
        // this.fetchDevResource()
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    }

  }
}
</script>
<style scoped>
  .interfacemanage {
    padding-top: 10px;
  }

  .interfacemanage .box-card{
    /* margin: 20px 0px; */
    padding: 20px 24px;
    margin-bottom: 20px;
    background-color: #fff;
  }

  .interfacemanage .content_wrapper{
    /* background-color: #ffffff;
    padding: 30px 20px;
    max-height: 100vh; */
  }
  .interfacemanage .content_wrapper .info-header{
    background: #ffffff;
    /* padding: 20px 24px; */
    position: relative;
    color: #333;
  }
  .interfacemanage .content_wrapper .info-header .title{
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .interfacemanage .content_wrapper .info-header .add,.interfacemanage .content_wrapper .info-header .time{
    font-size: 14px;
    color: gray;
    margin-bottom: 20px;
    max-width: 900px;
  }
  .interfacemanage .content_wrapper .info-header .user span{
    position: absolute;
    right: 162px;
    top: 85px;
    font-size: 18px;
    font-weight: bold;
  }
  .interfacemanage .content_wrapper .info-header .user img{
    position: absolute;
    right: 244px;
    top: 80px;
  }
  .interfacemanage .toolbar .el-select {
    width: 130px;
  }
  .interfacemanage .toolbar .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }

</style>
<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/pages/admin/interface-manage/index.vue